module.exports = __webpack_public_path__ + "img/22.cf584662.jpg";